export default{
  shopDecoration:{
    Button:{
    },
    EntpInfoData:{
    },
    Placeholder:{
    },
    shopCommCatgList:{
    },
    sort:{
    },
    Table:{
    },
    Dialog:{
    },
    Message:{
    },
    Title:{
        title1:'标题设置'
    }
    
  }
  
}